// Shared by the panel and the history modal so the two can never disagree on what
// a status looks like.

export const STATUS_LABEL: Record<string, string> = {
	OK: "Reading normally",
	FOLDER_DOWN: "Folder unreachable",
	NO_REPORT: "Service not reporting",
};

// FOLDER_DOWN is red and NO_REPORT amber on purpose: the panel only has room for
// one icon, so the colour is what tells a dead folder from a dead service.
export const STATUS_COLOR: Record<string, string> = {
	OK: "#2e7d32",
	FOLDER_DOWN: "#c62828",
	NO_REPORT: "#ef6c00",
};

export const NEVER_REPORTED_LABEL = "Never reported";

// Shared so the panel tooltip and the settings screen word it the same way.
export const humanSeconds = (s: number) =>
	s < 60 ? `${s} s` : `${Math.round(s / 60)} min`;
